;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.common.controllers')
    .controller('HeaderController', HeaderController)
  HeaderController.$inject = ['NotificationService']

  function HeaderController (NotificationService) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        countNotifications: countNotifications
      })
    }
    function countNotifications () {
      return NotificationService.countNotifications()
    }
  }
})(window.angular, window._)
